var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip',{attrs:{"text":_vm.workspaceWorkingSince}},[_c('div',{key:_vm.now,staticClass:"runningSince"},[_vm._v(_vm._s(_vm.upTime))])])}
var staticRenderFns = []

export { render, staticRenderFns }